import React, { useState } from "react";

import PropTypes from "prop-types";

import DataTable from "../DataTable";

import { ALL_ROUTES_VIEW_QUERY } from "../../graphql/Routes/Routes.graphql";

import { ROUTE_VIEW_COLUMNS } from "../../pages/DispatchProcessing/Routes/columns";

import { RouteFilters } from "../filters";

const RouteGridSelect = ({ where = {}, onRowClick }) => {
  const [filters, setFilters] = useState(() => where);

  return (
    <div className="modal-grid-select">
      <RouteFilters filters={filters} onChange={setFilters} />
      <DataTable
        columns={ROUTE_VIEW_COLUMNS}
        dataQuery={ALL_ROUTES_VIEW_QUERY}
        initialSortBy={[{ id: "RouteId", desc: false }]}
        name="VW_Route"
        where={filters}
        onRowClick={onRowClick}
      />
    </div>
  );
};

RouteGridSelect.propTypes = {
  where: PropTypes.object,
  onRowClick: PropTypes.func
};

export default RouteGridSelect;
